import * as React from 'react'
import Loading from '@components/Loading'
import { getToken } from './OneLoginForm'

export default () => {
  React.useEffect(() => {
    const assert = getToken()
    if (assert) {
      window.parent.pushOneLogin = true
      setTimeout(
        () => (window.parent.location.href = `#/one-login?token=${assert}`),
        500
      )
    }
  }, [])
  return <Loading />
}
